///////////////////////////////////////////////////////////////////////////////////
// Retrieve NOUS API Key
////////////////////////////////////////////////////////////////////////////////////
var nous_api_data;
// jQuery.ajax({
//      type: "POST",
//      // async: false,
//      url: '/wp-admin/admin-ajax.php',
//      dataType: 'json',
//      data: {
//       'action' : 'nous_retrieve_api_data',
//      },
//      success:function(response) {

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Set API Data
//         ////////////////////////////////////////////////////////////////////////////////////
//         nous_api_data = response;

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Set Global Ajax Settings
//         ////////////////////////////////////////////////////////////////////////////////////
//         jQuery.ajaxSetup({
//           headers: {
//             'X-Api-Key': response.client_key,
//           }
//         });

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Display Forms
//         ////////////////////////////////////////////////////////////////////////////////////
//         jQuery('form').css('opacity', '1');

//      },
// });

////////////////////////////////////////////////////////////////////////////////////
// Persistant Session Storage
////////////////////////////////////////////////////////////////////////////////////
if (!sessionStorage.length) {
  // Ask other tabs for session storage
  localStorage.setItem('getSessionStorage', Date.now());
};

window.addEventListener('storage', function(event) {

  if (event.key == 'getSessionStorage') {

    localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    localStorage.removeItem('sessionStorage');

  } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
    // sessionStorage is empty -> fill it

    var data = JSON.parse(event.newValue),
          value;

    for (key in data) {
      sessionStorage.setItem(key, data[key]);
    }

  }
});

////////////////////////////////////////////////////////////////////////////////////
// Generate Google reCaptcha V3 Token
////////////////////////////////////////////////////////////////////////////////////
function generate_google_recaptcha_token(action) {
  return new Promise(function(resolve, reject) {
      grecaptcha.execute(jQuery('body').attr('data-recaptcha-key'), {
        action: action
      })
      .then(function(token) {

        ////////////////////////////////////////////////////////////////////////////////////
        // Ajax - Validate Response
        ////////////////////////////////////////////////////////////////////////////////////
        jQuery.ajax({
          type: "POST",
          url: '/wp-admin/admin-ajax.php',
          data: {
            'action':'ajax_recaptcha_validate',
            'captcha_token' : token,
            'captcha_action' : action,
          },
          success:function(response) {
            resolve(response);
          }
        });
      });
  });
}

////////////////////////////////////////////////////////////////////////////////////
// Header Offset
////////////////////////////////////////////////////////////////////////////////////
function getHeaderOffset() {

  ////////////////////////////////////////////////////////////////////////////////////
  // Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var headerOuterHeight = 0;

  ////////////////////////////////////////////////////////////////////////////////////
  // Get Sticky Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  // if (jQuery('header').hasClass('js-sticky-top')) {
  headerOuterHeight = jQuery('header').outerHeight() + 50;
  // }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  return headerOuterHeight;

}

////////////////////////////////////////////////////////////////////////////////////
// Sticky Header
////////////////////////////////////////////////////////////////////////////////////
function nous_sticky_scroll_header() {
  var header = jQuery("body").find('header');
  var scroll_up = "sticky-scroll-up";
  var scroll_down = "sticky-scroll-down";

  var last_scroll_position = 0;

  function handleScroll() {
    // Skip sticky logic if Bootstrap collapse is open
    if (jQuery('body.navbar-active').length > 0) {
      return;
    }

    var current_scroll_position = jQuery(window).scrollTop();

    // Check if user is scrolling up - less then or equal to 150px from top
    if (current_scroll_position <= 150) {
      header.removeClass(scroll_down).removeClass(scroll_up);
    }
    // Check if user is scrolling up
    else if (current_scroll_position < last_scroll_position) {
      header.removeClass(scroll_down).addClass(scroll_up);
    }
    // User is scrolling down
    else {
      header.removeClass(scroll_up).addClass(scroll_down);
    }

    // Update scroll position
    last_scroll_position = current_scroll_position;
  }

  // Run on scroll
  jQuery(window).scroll(handleScroll);

  // Run on initial load
  // handleScroll();
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Mandrill JSON Payload
////////////////////////////////////////////////////////////////////////////////////
function mandrill_json_payload(fid) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Declare Form Data Object Array
  ////////////////////////////////////////////////////////////////////////////////////
  var mandrillData = new Object();
  mandrillData.customFields = {}
  var mandrillAttachments = []

  ////////////////////////////////////////////////////////////////////////////////////
  // Mandrill Settings
  ////////////////////////////////////////////////////////////////////////////////////
  mandrillData.recipients = jQuery(fid).data('form-recipients'); // Form Recipients
  mandrillData.fromName = jQuery(fid).data('form-from-name'); // From Name
  mandrillData.fromEmail = jQuery(fid).data('form-from-email-address'); // From Email Address
  mandrillData.subjectLine = jQuery(fid).data('form-subject-line'); // Form Subject Line
  mandrillData.notificationCopy = jQuery(fid).data('form-email-body'); // Email Body Copy

  ////////////////////////////////////////////////////////////////////////////////////
  // Get all data fields
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery( fid + ' *[data-field-name]' ).each(function( index, value ) {

    ////////////////////////////////////////////////////////////////////////////////////
    // Grouped Field Type - Checkboxs | Radio Buttons
    ////////////////////////////////////////////////////////////////////////////////////
    if(jQuery(this).is('[data-field-group]')) {

      var groupedID = jQuery(this).data('field-group');
      var groupedValue = [];

      ////////////////////////////////////////////////////////////////////////////////////
      // Push Array of checked fields
      ////////////////////////////////////////////////////////////////////////////////////
      jQuery( this ).find('[name="' + groupedID + '"]').each(function( index ) {
        if(jQuery(this).is(':checked')) {
          groupedValue.push(jQuery(this).val());
        }
      });

      ////////////////////////////////////////////////////////////////////////////////////
      // Append Group Data to data
      ////////////////////////////////////////////////////////////////////////////////////
      if(groupedValue.length) {
        mandrillData.customFields[jQuery(this).data('field-name')] = groupedValue.join();
      }

    ////////////////////////////////////////////////////////////////////////////////////
    // Standard Field Type
    ////////////////////////////////////////////////////////////////////////////////////
    } else {
      mandrillData.customFields[jQuery(this).data('field-name')] = jQuery(this).val();
    }

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Attachments
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery( fid + ' *[data-file-base-64]' ).each(function( index, value ) {

    mandrillAttachments.push({
      'name' : jQuery(this).attr('data-filename'),
      'type' : jQuery(this).attr('data-mimetype'),
      'content' : jQuery(this).attr('data-file-base-64')
    });

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Assign Attachments
  ////////////////////////////////////////////////////////////////////////////////////
  if(mandrillAttachments.length > 0) {
    mandrillData['attachments'] = mandrillAttachments;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Data
  ////////////////////////////////////////////////////////////////////////////////////
  return JSON.stringify(mandrillData);

}

////////////////////////////////////////////////////////////////////////////////////
// NOUS Anchor Link Hash
////////////////////////////////////////////////////////////////////////////////////
function nous_anchor_link_hash(hash) {
  // Exclude "Chosen" (https://harvesthq.github.io/chosen/) dropdowns from hash scroll
  // as they are not compatible with the scroll to hash functionality
  // - no hash present, results in a JS error
  if (jQuery(this).hasClass('chosen-single')) {
    return;
  }
  
  // Fixed Nav Offset
  var header_offset = getHeaderOffset();
  
  // Scroll to w/ Animation
  if(jQuery('*[data-scroll-element="' + hash + '"]').length) {
    jQuery('html, body').animate({
      scrollTop: jQuery('*[data-scroll-element="' + hash + '"]').offset().top - header_offset
    }, 0);
  }
}

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Flip Cards Module
////////////////////////////////////////////////////////////////////////////////////
function flexi_flip_cards_module() {
  (function($) {

    var block = $('.section-flexi-flip-cards');

    block.each(function() {
      $(this).find('.js-card-flip').on('click', function() {
        $(this).toggleClass('flipped');
      });
    });

  })(jQuery);
}

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Tabs Module
////////////////////////////////////////////////////////////////////////////////////
function flexi_tab_module() {
  (function($) {

    var block = $('.section-flexi-tab-module');

    block.each(function() {
      $(this).find('.js-flexi-tab-module-tab').on('click', function() {
        var tab_id = $(this).attr('data-index');

        $(this).siblings('.js-flexi-tab-module-tab').removeClass('active');
        $(this).addClass('active');

        $(this).parent().siblings('.js-flexi-tab-module-content').fadeOut(200, function() {
          $(this).removeClass('d-flex').addClass('d-none');
        });

        $(this).parent().siblings('.js-flexi-tab-module-content[data-index="' + tab_id + '"]').fadeIn(200, function() {
          $(this).addClass('d-flex').removeClass('d-none');
        });
      });
    });

  })(jQuery);
}

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Dynamic Selective Content Module
////////////////////////////////////////////////////////////////////////////////////
function flexi_dynamic_selective_content_module() {
  (function($) {

    var block = $('.section-flexi-dynamic-selective-content');

    function updateBlockHeight(block) {
      block.each(function() {
        var block_height = $(this).find('.container').outerHeight();
        $(this).css('min-height', block_height + 'px');
      });
    }
  
    // Set the initial min-height
    updateBlockHeight(block);
  
    // Update the min-height on window resize
    $(window).on('resize', function() {
      updateBlockHeight(block);
    });

    block.each(function() {
      var debounceTimer;
    
      function handleInteraction(tab_id) {
        var dynamic_content_wrapper = '.flexi-dynamic-selective-content-dynamic-content';
        var dynamic_image_wrapper = '.flexi-dynamic-selective-content-dynamic-images';
    
        var dynamic_content = '.js-flexi-dynamic-selective-content-content';
        var dynamic_image = '.js-flexi-dynamic-selective-content-image';

        var fadeDuration = 300;
    
        // Remove active class from all headings
        block.find('.js-flexi-dynamic-selective-content-heading').removeClass('active');
    
        // Add active class to current heading
        block.find('.js-flexi-dynamic-selective-content-heading[data-index="' + tab_id + '"]').addClass('active');
    
        // Hide all content & images
        block.find(dynamic_content_wrapper)
          .find(dynamic_content).siblings().fadeOut(fadeDuration, function() {
            $(this).removeClass('d-flex').addClass('d-none');
          });
    
        block.find(dynamic_image_wrapper)
          .find(dynamic_image).siblings().fadeOut(fadeDuration, function() {
            $(this).removeClass('d-flex').addClass('d-none');
          });
    
        // Show selected content & image
        block.find(dynamic_content_wrapper)
          .find(dynamic_content + '[data-index="' + tab_id + '"]').fadeIn(fadeDuration, function() {
            $(this).addClass('d-flex').removeClass('d-none');
          });
    
        block.find(dynamic_image_wrapper)
          .find(dynamic_image + '[data-index="' + tab_id + '"]').fadeIn(fadeDuration, function() {
            $(this).addClass('d-flex').removeClass('d-none');
          });
      }
    
      $(this).find('.js-flexi-dynamic-selective-content-heading')
        .on('click touchstart', function(event) {
          event.preventDefault();
          var tab_id = $(this).attr('data-index');
          handleInteraction(tab_id);
        })
        .on('mouseenter', function() {
          if (window.matchMedia('(min-width: 1140px)').matches) { // Check if screen width is at least 1140px
            var tab_id = $(this).attr('data-index');
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function() {
              handleInteraction(tab_id);
            }, 100); // Adjust debounce delay as needed
          }
        })
        .on('mouseleave', function() {
          if (window.matchMedia('(min-width: 1140px)').matches) {
            clearTimeout(debounceTimer);
          }
        });
    });

  })(jQuery);
}

////////////////////////////////////////////////////////////////////////////////////
// Flexible Content: Brand Carousel
////////////////////////////////////////////////////////////////////////////////////
function flexi_brand_carousel_module() {
  (function($) {

    var block = $('.section-flexi-brand-carousel');

    block.each(function() {
      var brand_carousel = $(this).find('.js-brand-carousel');
      var scrollSpeed = 1; // Adjust the speed of scrolling
      var isHovered = false;
      var animationFrame;

      // Function to scroll the carousel
      function scrollCarousel() {
        if (!isHovered) {
          var currentScroll = brand_carousel.scrollLeft();
          var maxScroll = brand_carousel[0].scrollWidth - brand_carousel.outerWidth();

          // If the carousel reaches the end, reset to the start
          if (currentScroll >= maxScroll) {
            brand_carousel.fadeOut(250, function() {
              brand_carousel.scrollLeft(0); // Reset to the start
              brand_carousel.fadeIn(250); // Fade back in
            });
          } else {
            brand_carousel.scrollLeft(currentScroll + scrollSpeed);
          }
        }
        animationFrame = requestAnimationFrame(scrollCarousel);
      }

      // Start scrolling on load
      scrollCarousel();

      // Pause scrolling on hover
      brand_carousel.on('mouseenter touchstart', function() {
        isHovered = true;
        cancelAnimationFrame(animationFrame);
      });

      // Resume scrolling on mouse leave or touch end
      brand_carousel.on('mouseleave touchend', function() {
        isHovered = false;
        scrollCarousel();
      });
    });

  })(jQuery);
}

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Split Column Scrollable Content
////////////////////////////////////////////////////////////////////////////////////
function flexi_split_column_scrollable_content() {
  (function($) {

    var block = $('.section-flexi-split-column-scrollable-content');
    block.each(function() {
      var scroll_content = $(this).find('.js-content-copy-wrapper'); // Target scrollable content
      var feature_content = $(this).find('.js-feature-content-wrapper'); // Target feature content

      // Function to check if elements within scroll_content hit the middle of the screen
      function checkBlockPosition() {
        var fade_duration = 500;

        var scroll_top = $(window).scrollTop(); // Current scroll position
        var window_height = $(window).height(); // Height of the viewport
        var middle_of_screen = scroll_top + (window_height / 2); // Middle of the screen

        var block_top = block.offset().top; // Top position of the block
        var block_bottom = block_top + block.outerHeight(); // Bottom position of the block

        // Remove active class if the block is scrolled past or above
        if (scroll_top > block_bottom || scroll_top + window_height < block_top) {          
          feature_content.find('.js-feature-content').removeClass('d-xl-flex').addClass('d-xl-none');
          // feature_content.find('.feature-content .feature-content-image').removeClass('active');
          feature_content.find('.feature-content .feature-content-image').fadeOut(fade_duration, function() {
            $(this).removeClass('active');
          });

          scroll_content.find('.content-copy-inner').children().removeClass('active');

          return; // Exit early if the block is out of view
        }

        // Iterate through each child element of scroll_content
        scroll_content.find('.content-copy-inner').children().each(function() {
          var element_top = $(this).offset().top; // Top position of the element
          var element_height = $(this).outerHeight(); // Height of the element
          var element_middle = element_top + (element_height / 2); // Middle of the element

          var feature_content_id = $(this).attr('id'); // Get the data-content-id attribute

          // Add the active class if the element's middle is at the middle of the screen
          if (Math.abs(element_middle - middle_of_screen) <= 50) { // Allow a small margin of error
            if (!$(this).hasClass('active')) { // Add class only once
              $(this).addClass('active');

              feature_content.find('.feature-content').siblings().removeClass('d-xl-flex').addClass('d-xl-none');
              feature_content.find('.feature-content[data-id="' + feature_content_id + '"]').addClass('d-xl-flex').removeClass('d-xl-none');             
              feature_content.find('.feature-content[data-id="' + feature_content_id + '"] .feature-content-image').fadeIn(fade_duration, function() {
                $(this).addClass('active');
              });
            }
          }

          // Remove the active class if the element is above the top or below the bottom of the screen
          if (element_top + element_height < scroll_top || element_top > scroll_top + window_height) {
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
            }
          }
        });
      }

      // Attach the scroll event
      $(window).on('scroll', checkBlockPosition);

      // Run the check on page load
      checkBlockPosition();
    });

  })(jQuery);
}

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: History Module
////////////////////////////////////////////////////////////////////////////////////
function flexi_history_module() {
  (function($) {
    
    var block = $('.section-flexi-history-module');    
    block.each(function() {
      var carousel = $(this).find('.js-history-content-carousel');
      var carouselCells = carousel.find('.carousel-cell');
      var carouselNav = $(this).find('.js-history-carousel-nav');
      var carouselNavCells = carouselNav.find('.carousel-cell');

      var previousNavButton = $(this).find('.js-carousel-prev-button');
      var nextNavButton = $(this).find('.js-carousel-next-button');

      var animationDuration = 0; //500; // Adjust animation duration as needed

      ////////////////////////////////////////////////////////////////////////////////////
      // Carousel Height
      ////////////////////////////////////////////////////////////////////////////////////
      function setCarouselHeight() {
        carousel.css({ 'min-height' : '' }); // Reset min-height
        
        var carouselContentHeight = carousel.outerHeight();
        carousel.css({ 'min-height' : carouselContentHeight + 'px' });
      }

      // Set the initial height
      setCarouselHeight();

      // Recalculate height on window resize
      $(window).on('resize', function() {
        setCarouselHeight();
      });
      ////////////////////////////////////////////////////////////////////////////////////

      ////////////////////////////////////////////////////////////////////////////////////
      // Carousel Scroll
      ////////////////////////////////////////////////////////////////////////////////////
      function carouselScroll() {
        var carouselCenter = carousel.scrollLeft() + (carousel.outerWidth() / 2); // Center of the carousel
        var scrollLeft = carousel.scrollLeft(); // Current scroll position
        var maxScroll = carousel[0].scrollWidth - carousel.outerWidth(); // Maximum scroll position
        
        if (carouselCells.first().hasClass('active')) {
          previousNavButton.addClass('d-none');
        } else {
          previousNavButton.removeClass('d-none');
        }

        if (carouselCells.last().hasClass('active')) {
          nextNavButton.addClass('d-none');
        } else {
          nextNavButton.removeClass('d-none');
        }

        if (scrollLeft === 0) {
          
          // If at the start, activate the first cell
          var firstCell = carouselCells.first();
          firstCell.addClass('active');
          firstCell.siblings().removeClass('active');

        } else if (scrollLeft >= maxScroll) {

          // If at the end, activate the last cell
          var lastCell = carouselCells.last();
          lastCell.addClass('active');
          lastCell.siblings().removeClass('active');

        } else {

          // Otherwise, check which cell is at the center
          carouselCells.each(function () {
            var cell = $(this);
            var cellStart = cell.offset().left - carousel.offset().left + carousel.scrollLeft(); // Start position of the cell
            var cellEnd = cellStart + cell.outerWidth(); // End position of the cell
      
            if (cellStart <= carouselCenter && cellEnd >= carouselCenter) {
              cell.addClass('active'); // Add class to the active cell
              cell.siblings().removeClass('active'); // Remove class from other cells
            }
          });

        }

        // Update carouselNav
        var activeIndex = carousel.find('.carousel-cell.active').attr('data-index');
        var targetNavCell = carouselNav.find('.carousel-cell[data-index="' + activeIndex + '"]');

        // Smoothly scroll carouselNav to the active cell
        if (targetNavCell.length) {
          carouselNav.stop(true).animate({
            scrollLeft: carouselNav.scrollLeft() + targetNavCell.position().left - (carouselNav.outerWidth() / 2) + (targetNavCell.outerWidth() / 2)
          }, animationDuration); // Adjust animation duration as needed

          // Update active class in carouselNav
          targetNavCell.addClass('active').siblings().removeClass('active');
        }
      }

      // Debounce the scroll event to avoid excessive updates
      var debounceTimer;
      carousel.on('scroll', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(carouselScroll, 100); // Adjust debounce delay as needed
      });
      ////////////////////////////////////////////////////////////////////////////////////

      ////////////////////////////////////////////////////////////////////////////////////
      // Carousel - Prev & Next
      ////////////////////////////////////////////////////////////////////////////////////
      function moveCarousel(direction) {
        var activeCarouselCells = carouselCells.filter('.active');
        var newActiveCarouselCell;

        if (direction === 'prev') {
          newActiveCarouselCell = activeCarouselCells.prev('.carousel-cell');
        } else if (direction === 'next') {
          newActiveCarouselCell = activeCarouselCells.next('.carousel-cell');
        }
        
        // Check if newActiveCarouselCell exists and has elements
        if (newActiveCarouselCell && newActiveCarouselCell.length) {
          
          // Center the newActiveCarouselCell in the carousel
          var carousel = newActiveCarouselCell.closest('.js-history-content-carousel'); // Adjust selector if needed
          var carouselWidth = carousel.outerWidth();
          var cellPosition = newActiveCarouselCell.position().left;
          var cellWidth = newActiveCarouselCell.outerWidth();
          
          var scrollPosition = carousel.scrollLeft() + cellPosition - (carouselWidth / 2) + (cellWidth / 2);
          carousel.animate({ scrollLeft: scrollPosition }, 500, function() {
            carouselCells.siblings().removeClass('active'); // Remove active class from all cells
            newActiveCarouselCell.addClass('active');
          }); // Smooth scroll to center
        }
      }

      // Attach click events to previous and next buttons
      previousNavButton.on('click', function() {
        moveCarousel('prev');
      });

      nextNavButton.on('click', function() {
        moveCarousel('next');
      });
      ////////////////////////////////////////////////////////////////////////////////////
      
      ////////////////////////////////////////////////////////////////////////////////////
      // Carousel - Timeline Navigation
      ////////////////////////////////////////////////////////////////////////////////////
      carouselNavCells.each(function () {
        $(this).find('.js-history-nav-button').on('click', function () {
          var carousel = $(this).closest('.js-flexi-history-module-carousel');
          var carouselContent = carousel.find('.js-history-content-carousel');
          var navButtonId = $(this).attr('data-index');
          var targetCell = carouselContent.find('.carousel-cell[data-index="' + navButtonId + '"]');
      
          // Calculate the target scroll position
          var targetScrollLeft = carouselContent.scrollLeft() + targetCell.position().left - (carouselContent.outerWidth() / 2) + (targetCell.outerWidth() / 2)
      
          // Animate to the target position
          carouselContent.animate(
            { scrollLeft: targetScrollLeft },
            animationDuration, // Adjust animation duration as needed
            function () {
              // Ensure the target cell is marked as active after the animation
              targetCell.addClass('active').siblings().removeClass('active');
            }
          );
      
          // Update the active class in the navigation
          carouselNavCells.removeClass('active');
          $(this).parent().addClass('active');
        });
      });
      ////////////////////////////////////////////////////////////////////////////////////

    });

  })(jQuery);
}

////////////////////////////////////////////////////////////////////////////////////
// Document Ready
////////////////////////////////////////////////////////////////////////////////////
jQuery( document ).ready(function($) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Anchor Link Hash
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', 'a', function() {

    var hash = $(this).attr('href').split('#');
    nous_anchor_link_hash(hash[1]);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Site Wide Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var nousThemeName = $('body').attr('data-nous-theme');
  var googleMapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}];

  ////////////////////////////////////////////////////////////////////////////////////
  // Determine if is retina device
  ////////////////////////////////////////////////////////////////////////////////////
  function isRetinaDisplay() {
    if (window.matchMedia) {
      var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
      return (mq && mq.matches || (window.devicePixelRatio > 1));
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Base64 File
  ////////////////////////////////////////////////////////////////////////////////////
  function base64File(file, onLoadCallback) {
      return new Promise(function(resolve, reject) {
          var reader = new FileReader();
          reader.onload = function() { resolve(reader.result); };
          reader.onerror = reject;
          reader.readAsDataURL(file);
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Generate Munchkin Hash
  ////////////////////////////////////////////////////////////////////////////////////
  function generate_munchkin_hash(email) {

    return $.ajax({
      type: "POST",
      url: '/wp-admin/admin-ajax.php',
      data: 'email=' + email + '&action=generate_munchkin_hash',
      dataType: 'json',
    });

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Google Maps Init
  ////////////////////////////////////////////////////////////////////////////////////
  function init_google_map() {

    ////////////////////////////////////////////////////////////////////////////////////
    // Each Google Map
    ////////////////////////////////////////////////////////////////////////////////////
    $( '.js-init-google-map' ).each(function( index ) {

        ////////////////////////////////////////////////////////////////////////////////////
        // Variables
        ////////////////////////////////////////////////////////////////////////////////////
        var myLatLng = {lat: $(this).data('lat'), lng: $(this).data('lng')};
        // var mapInfoWindow = $(this).attr('data-info-window');
        // var markerIcon = new google.maps.MarkerImage('/wp-content/themes/' + nousThemeName + '/assets/img/map-marker.png', null, null, null, new google.maps.Size(30,40));


        ////////////////////////////////////////////////////////////////////////////////////
        // Create Map
        ////////////////////////////////////////////////////////////////////////////////////
        var map = new google.maps.Map(document.getElementById($(this).attr('id')), {
          zoom: 12,
          center: myLatLng,
          styles: googleMapStyles
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Marker
        ////////////////////////////////////////////////////////////////////////////////////
        var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Info Window
        ////////////////////////////////////////////////////////////////////////////////////
        var infowindow = new google.maps.InfoWindow({
          content: mapInfoWindow,
          // pixelOffset: new google.maps.Size(5, 20)
        });
        infowindow.open(map, marker);

    }); // END EACH

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Onload Functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(window).load(function() {

      ////////////////////////////////////////////////////////////////////////////////////
      // Hash Onload Scroll To Functionality
      ////////////////////////////////////////////////////////////////////////////////////
      if(window.location.hash) {

        setTimeout(function() {

          var hash = window.location.hash;
          hash = hash.split('#');

          nous_anchor_link_hash(hash[1]);

        }, 500);

      } // END HASH

      ////////////////////////////////////////////////////////////////////////////////////
      // Initialize Google Map
      ////////////////////////////////////////////////////////////////////////////////////
      init_google_map();

      ////////////////////////////////////////////////////////////////////////////////////
      // Trunc8 Function
      ////////////////////////////////////////////////////////////////////////////////////
      $( '.js-trunc8' ).each(function( index ) {

        var lineCount = $(this).attr('data-trunc8-line');

        $(this).trunk8({
          lines: parseInt(lineCount)
        });

      });

  }); // END ONLOAD


  ////////////////////////////////////////////////////////////////////////////////////
  // Clear input on focus
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('focus', '.js-clear-input', function() {

    $(this).val('');

    return false;

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Initialize Marketo Instance
  ////////////////////////////////////////////////////////////////////////////////////
  // $.ajax({
  //   url: '//munchkin.marketo.net/munchkin.js',
  //   dataType: 'script',
  //   cache: true,
  //   success: function() {
  //     Munchkin.init('[KEY]');
  //   }
  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Save To Disk Function
  ////////////////////////////////////////////////////////////////////////////////////
  // function SaveToDisk(fileURL, fileName) {
  //     // for non-IE
  //     if (!window.ActiveXObject) {
  //         var save = document.createElement('a');
  //         save.href = fileURL;
  //         save.target = '_blank';
  //         save.download = fileName || 'unknown';

  //         var evt = new MouseEvent('click', {
  //             'view': window,
  //             'bubbles': true,
  //             'cancelable': false
  //         });
  //         save.dispatchEvent(evt);

  //         (window.URL || window.webkitURL).revokeObjectURL(save.href);
  //     }

  //     // for IE < 11
  //     else if ( !! window.ActiveXObject && document.execCommand)     {
  //         var _window = window.open(fileURL, '_blank');
  //         _window.document.close();
  //         _window.document.execCommand('SaveAs', true, fileName || fileURL)
  //         _window.close();
  //     }
  // }

  ////////////////////////////////////////////////////////////////////////////////////
  // Scroll To Event
  ////////////////////////////////////////////////////////////////////////////////////
  // $(document).on('click', '.js-scroll-to', function() {

  //   // Scroll to
  //   var scrollTo = $(this).attr('data-scroll-to');

  //   // Header Position Offset
  //   if($('.header-top').css('position') === 'fixed') {
  //     var headerHeight = $('.js-navbar-fixed-top').outerHeight();
  //   } else {
  //     var headerHeight = 0;
  //   }

  //   $('html, body').animate({
  //    scrollTop: $('*[data-scroll-element="' + scrollTo + '"]').offset().top
  //   }, 0);

  //   return false;

  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Marketo IE10 Bug fix
  ////////////////////////////////////////////////////////////////////////////////////
  (function () {
    'use strict';
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
      var msViewportStyle = document.createElement('style')
      msViewportStyle.appendChild(
        document.createTextNode(
          '@-ms-viewport{width:auto!important}'
        )
      )
      document.querySelector('head').appendChild(msViewportStyle)
    }
  })();

  ////////////////////////////////////////////////////////////////////////////////////
  // File Type - Data Attributes
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change', '.js-base64-file', function() {

     ////////////////////////////////////////////////////////////////////////////////////
     // Base64 File Contents
     ////////////////////////////////////////////////////////////////////////////////////
     var inputID = $(this).attr('id');
     var fileInput = document.querySelector('#' + inputID).files[0];

     ////////////////////////////////////////////////////////////////////////////////////
     // Assign Base64 to file
     ////////////////////////////////////////////////////////////////////////////////////
     var fileInputBase64 = base64File(fileInput, function(e) {
     }).then(function(result) {
      var formatted = result.split(',');
      $('#' + inputID).attr('data-file-base-64', formatted[1]);
     });

     ////////////////////////////////////////////////////////////////////////////////////
     // Assign other attributes to file input
     ///////////////////////////////////////////////////////////////////////////////////
     $('#' + inputID).attr('data-filename', fileInput.name);
     $('#' + inputID).attr('data-mimetype', fileInput.type);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // FAQ accordion toggle functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', '.js-panel', function() {

      $('.panel-collapse').removeClass('in');

      if($(this).parent('.panel').hasClass('active')) {
        $(this).parent('.panel').removeClass('active');
        $(this).siblings('.panel-collapse').removeClass('in');
      } else {
        $('.js-panel').parent('.panel').removeClass('active');
        $(this).parent('.panel').addClass('active');
        $(this).siblings('.panel-collapse').addClass('in');
      }

      return false;
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // jQuery Validate Phone Method - Uses Google Lib
  ////////////////////////////////////////////////////////////////////////////////////
  $.validator.addMethod("validPhone", function(value, element) {

      if(value == '') { return true; }

      try {

          var phoneUtil = i18n.phonenumbers.PhoneNumberUtil.getInstance();
          var number = phoneUtil.parseAndKeepRawInput(value, 'AU');

          if(phoneUtil.isValidNumber(number)) {

              return true;

          } else {

              return false;

          }

      }
      catch(ex) {
          return false;
          console.log(ex);
      }

  }, "Please enter a valid phone number (including area code for land lines)");

});